import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications-panel',
  standalone: false,
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.scss'
})
export class NotificationsPanelComponent {
  constructor( private router: Router,) { }

  @Input() notificaciones: any[] = [];
  @Output() onMarcarLeida = new EventEmitter<any>();
  @Output() onVerTodas = new EventEmitter<void>();

  // Máx 8
  get notificacionesLimitadas() {
    return this.notificaciones.slice(0, 8);
  }

  marcarComoLeida(notif: any) {
    notif.leida = true;
    this.onMarcarLeida.emit(notif);
  }

  verTodas() {
    this.onVerTodas.emit();
    this.router.navigate(['/notificaciones']);
  }
}
